module.exports = __webpack_public_path__ + "img/img19.bbf488a4.png";